import { useEffect } from 'react';

import orderLookupMap from '@/assets/illustrations/order-lookup-map.svg';
import { Heading1 } from '@/components/common/Heading1';
import { getLighthouseTrackUrl } from '@/lib/constants';
import { LOGGER_ACTIONS, logger } from '@/lib/logger';

// Brief pause so the "Welcome back" confirmation is visible before the redirect.
const REDIRECT_DELAY_MS = 1500;

interface OrderLookupHandoffProps {
  firstName: string;
  publicId: string;
}

// Cross-origin redirect to Lighthouse, so window.location.assign rather than TanStack
// navigate; the browser sends the httpOnly handoff cookie on redeem.
export function OrderLookupHandoff({ firstName, publicId }: OrderLookupHandoffProps) {
  useEffect(
    function redirectToLighthouse() {
      logger.action(LOGGER_ACTIONS.ORDER_LOOKUP.HANDOFF);

      const timeoutId = window.setTimeout(() => {
        window.location.assign(getLighthouseTrackUrl(publicId));
      }, REDIRECT_DELAY_MS);

      return () => window.clearTimeout(timeoutId);
    },
    [publicId]
  );

  return (
    <section
      className="flex flex-col items-center justify-center gap-6 py-16 text-center"
      role="status"
      aria-busy="true"
    >
      <img src={orderLookupMap} alt="" aria-hidden className="h-auto w-full max-w-[259px]" />
      <div className="flex flex-col gap-4">
        <Heading1 className="mb-0 pb-0 sm:mb-0">
          Welcome back{firstName ? `, ${firstName}` : ''}!
        </Heading1>
        <p className="text-base text-charcoal-500">Taking you to manage your booking now...</p>
      </div>
    </section>
  );
}
